import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';

import { trackById, trackByValue } from '../../../shared/util';
import {
  PickListInterface,
  EPicklistOderStatus,
  PicklistPacking,
  PicklistStatus,
  EPicklistOrderSource,
  EPicklistPackingTableColSpan,
} from '../../interfaces';

@Component({
  selector: 'lum-picklist-packing-table',
  templateUrl: './picklist-packing-table.component.html',
  styleUrls: ['./picklist-packing-table.component.scss'],
})
export class PicklistPackingTableComponent implements OnInit, OnChanges {
  @Output()
  printLabelEvent = new EventEmitter<number>();

  @Output()
  printLabelWithPackingSlipEvent = new EventEmitter<number>();

  @Output()
  exportPackingSlipEvent = new EventEmitter<number>();

  @Output()
  selectEvent = new EventEmitter<PicklistPacking[]>();

  @Input()
  data :PicklistPacking[] = [];

  @Input()
  picklist :PickListInterface | null = null;

  @Input()
  loading :boolean = false;

  @Input()
  updatingStatus :boolean = false;

  @Input()
  loadingShipItems :{ [id :number] :boolean } = {};

  @Input()
  loadingBulkShip :boolean = false;

  @Output()
  shipEvent = new EventEmitter<number>();

  @Output()
  onHoldEvent = new EventEmitter<number>();

  @Output()
  verifyEvent = new EventEmitter<PicklistPacking>(); // TODO: Please double check the return type

  @Output()
  flagOrderEvent = new EventEmitter<number>();

  picklistOrderStatus = EPicklistOderStatus;
  trackByValue = trackByValue;
  trackById = trackById;
  toggledAll :boolean = false;
  packingTableColSpan = EPicklistPackingTableColSpan;

  constructor() {}

  ngOnInit() :void {}

  ngOnChanges(changes :SimpleChanges) :void {
    if (changes['data'] && this.data) {
      this.data = this.data.map((item) => ({ ...item, expanded: true }));
    }
  }

  toggleAll(event :MatCheckboxChange) :void {
    this.toggledAll = event.checked;
    this.data.forEach((row) => (row.checked = this.toggledAll));
    this.selectEvent.emit(this.selectedItems);
  }

  toggleItem(row :PicklistPacking, event :MatCheckboxChange) :void {
    row.checked = event.checked;
    if (this.data.every((item) => item.checked)) {
      this.toggledAll = true;
    }
    if (this.data.every((item) => !item.checked)) {
      this.toggledAll = false;
    }

    this.selectEvent.emit(this.selectedItems);
  }

  enableActions(picklistPacking :PicklistPacking) :boolean {
    const allowedOrderStatus :string[] = [
      EPicklistOderStatus.AWAITING_SHIPMENT,
      EPicklistOderStatus.PARTIALLY_SHIPPED,
      EPicklistOderStatus.PENDING,
    ];

    return allowedOrderStatus.includes(picklistPacking.orderStatus);
  }

  canPrintLabel(picklistPacking :PicklistPacking) :boolean {
    const order = this.picklist?.orders?.find(
      (order) => order.id === picklistPacking.id,
    );

    if (!order) {
      return false;
    }

    if (
      order.source === EPicklistOrderSource.LUMINOUS &&
      order.shipstationOrderId
    ) {
      return true;
    }

    if (order.source === EPicklistOrderSource.SHIPSTATION && order.channelId > 0) {
      return true;
    }

    return false;
  }

  get showPicklistActions() :boolean {
    if (!this.picklist) return false;

    return this.picklist.status !== PicklistStatus.PACKED;
  }

  get selectedItems() :PicklistPacking[] {
    return this.data.filter((item) => item.checked);
  }
}
